import { DateTime } from 'luxon';
import { v4 as uuid } from 'uuid'
import { JsaPhoto } from './jsa-photo.model'

export class JsaAndPhoto {
  jsa_id: number
  photo: JsaPhoto
}

export class JsaForm {
  uuid: string
  id: number
  jsa_id: number
  form_data: any
  signature_data: any
  created_at: string
  modified_at: string
  modified_by_id: number
  deleted_at: string
  deleted_by_id: number
  is_pending_save: boolean
  is_pending_delete: boolean

  constructor() {
  }

  setViewModelFields() {
    if (!this.id) {
      this.id = 0
    }
    if (!this.uuid) {
      this.uuid = uuid();
    }
    if (this.is_pending_save === undefined) {
        this.is_pending_save = false;
    }
    if (this.is_pending_delete === undefined) {
        this.is_pending_delete = false;
    }
  }

  static buildOne(obj: any): JsaForm {
    let target: JsaForm = Object.assign(new JsaForm(), obj)
    target.setViewModelFields()
    return target
  }

  static buildMany(objs: any[]): JsaForm[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(JsaForm.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

export class UuidAndIdAndJsaForms {
  uuid: string
  id: number
  jsa_form: JsaForm
}

export class Jsa {
  id = 0
  due_date = ''
  is_completed = false
  is_scheduled = false
  type = ''
  work_order_number = ''
  customer = ''
  location_name = ''
  unit_number = ''
  job_type: string
  due_date_vm = ''
  due_date_class_vm = ''
  photos: JsaPhoto[] = []
  photo_ids?: number[]
  jsa_forms: JsaForm[] = []
  deleted_photos: JsaPhoto[] = []

  setViewModelFields()
  {     
    const today = DateTime.now().toFormat('M/d/yyyy')    
    const due = DateTime.fromFormat(this.due_date, 'yyyy-MM-dd').toFormat('M/d/yyyy')    

    this.due_date_vm = today == due ? 'Today': due
    this.due_date_class_vm = today != due ? 'card-due-overdue' : 'card-due-due'
  }

  constructor() {
  }

  static buildOne(obj: any): Jsa {
    let target: Jsa = Object.assign(new Jsa(), obj)
    target.setViewModelFields()
    return target
  }

  static buildMany(objs: any[]): Jsa[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(Jsa.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

